module.exports = __webpack_public_path__ + "img/left_1.962481d0.jpg";